import { SET_AUTH,SET_SIMULATING_COUNT,SET_TIMER } from "./type";

export const setAuth = (auth: any) => ({
  type: SET_AUTH,
  payload: auth,
});

export const setTimer = () => ({
  type: SET_TIMER,
});


export const setSimulatingCount = (payload: number) => {
  return {
    type: SET_SIMULATING_COUNT,
    payload,
  }
};